<template>
    <div
        class="activity-completion-action-row tw:mt-4 tw:flex tw:flex-wrap tw:items-center tw:gap-4"
        :class="[isCorporate ? 'tw:justify-end' : 'tw:justify-between', { 'tw:mb-4': isCorporate }]"
    >
        <template v-if="isCorporate">
            <!-- Mark Complete (self-hides once complete) sits bottom-right. The Next /
                 "Complete Course" affordance + auto-redirect now live once in the corporate shell
                 (ActivityPageCorporate.vue), so every activity type gets them — not just the ones
                 that render this row. -->
            <div class="activity-completion-action-row__primary tw:ml-auto tw:flex tw:flex-wrap tw:items-center tw:justify-end tw:gap-2">
                <slot />
            </div>
        </template>
        <template v-else>
            <div class="activity-completion-action-row__primary tw:flex tw:flex-wrap tw:items-center tw:gap-2">
                <slot />
            </div>
            <div class="activity-completion-action-row__nav tw:ml-auto tw:flex tw:flex-shrink-0 tw:items-center tw:gap-2">
                <portal-target name="activity-prev-next-footer" />
            </div>
        </template>
    </div>
</template>

<script>
import { PortalTarget } from 'portal-vue';

import { isCorporateClient } from '@/composables/useEdverumClient.js';

export default {
    name: 'ActivityCompletionActionRow',

    components: { PortalTarget },

    computed: {
        isCorporate() {
            return isCorporateClient();
        },
    },
};
</script>

<style scoped>
/*
 * Stacked full-width actions on narrow viewports.
 * Tailwind max-md is max-width 767px (md = 768px min), so 768px-wide tablets kept the desktop row.
 * Match Bulma touch / tablet: max-width 768px, and override flex-shrink-0 on the nav column.
 */
@media screen and (max-width: 768px) {
    .activity-completion-action-row {
        flex-direction: column !important;
        flex-wrap: nowrap !important;
        align-items: stretch !important;
        gap: 0.75rem;
    }

    .activity-completion-action-row__primary {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }

    .activity-completion-action-row__primary > :deep(*) {
        width: 100%;
        max-width: 100%;
    }

    .activity-completion-action-row__nav {
        margin-left: 0 !important;
        width: 100%;
        flex-shrink: 1;
        min-width: 0;
        flex-direction: column;
        align-items: stretch;
    }

    .activity-completion-action-row__primary :deep(.p-button),
    .activity-completion-action-row__nav :deep(.p-button) {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }
}
</style>
